import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LinkRequestsGateway } from '../gateways/LinkRequestsGateway';
import { FailureReason } from '../models/LinkRequestStatus';

import { mapErrorToFailureReason } from './mapErrorToFailureReason';

interface AcceptLinkRequestFailureResult {
    success: false;
    failureReason: FailureReason;
}

export type AcceptLinkRequestResult = { success: true } | AcceptLinkRequestFailureResult;

@Injectable()
export class AcceptLinkRequestUseCase {
    constructor(@Inject('LinkRequestsGateway') private linkRequestsGateway: LinkRequestsGateway) {}

    exec(token: string): Observable<AcceptLinkRequestResult> {
        return this.linkRequestsGateway.acceptLinkRequest(token).pipe(
            map(() => ({ success: true as const })),
            catchError((error) => {
                const failureReason = mapErrorToFailureReason(error);
                return of({ success: false, failureReason });
            }),
        );
    }
}
